import { createContext } from 'react';
export const PageMetricContext = createContext<any>(null);
